import React from "react"
import CustomImage from "@/main/customImage"
import { useDispatch, useSelector } from "react-redux"

import { Formik } from "formik"
import * as Yup from "yup"
import { Form as FormikForm } from "formik"
import { Row } from "react-bootstrap"

import NameField from "@/fields/nameField"
import EmailField from "@/fields/emailField"
import PhoneField from "@/fields/phoneField"
import Recaptcha from "@/fields/recaptcha"
import SubmitButton from "@/fields/submitButton"

import {
    setFindHomeDataTwo,
    sendFindHomeData,
} from "@/slices/findHomeModalSlice"

function FindMeAHomeStepTwo(props) {
    const dispatch = useDispatch()

    // The selector to retrieve the find home form from state.
    // The selector to retrieve the find home form from state.
    const { status, formData } = useSelector((state) => state.findHomeModal)

    // A regular expression that can detect a small number of fake mobile
    // numbers that will be used for validation (doesn't allow chars).
    const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    // The schema used for validation of the request viewing form input.
    const FindHomeSchema = Yup.object().shape({
        fullName: Yup.string().required("This field is required."),
        email: Yup.string()
            .email("Must be a valid email.")
            .required("This field is required."),
        phone: Yup.string().matches(
            phoneRegExp,
            "Must be a valid phone number (digits only).",
        ),
        captcha: Yup.boolean().oneOf(
            [true],
            "Please confirm you are not a robot.",
        ),
    })

    // Dispatching the form data to the backend. This function is
    // called on form submit.
    const findHome = async (values) => {
        await dispatch(findMeAHome(values))
    }

    return (
        <>
            <Formik
                initialValues={formData}
                validationSchema={FindHomeSchema}
                // Send the form data to the backend
                onSubmit={async (values) => {
                    await dispatch(sendFindHomeData(values))
                }}
            >
                {(formik) => (
                    <FormikForm>
                        <Row>
                            <NameField formik={formik} />

                            <EmailField formik={formik} />

                            <PhoneField formik={formik} />
                        </Row>

                        <div className="d-none d-sm-inline">
                            <Recaptcha formik={formik} size="normal" />
                        </div>
                        <div className="d-sm-none">
                            <Recaptcha formik={formik} size="compact" />
                        </div>

                        <SubmitButton
                            submit_message="Send details"
                            status={status}
                            formik={formik}
                        />

                        <a
                            href="#"
                            className="ms-auto my-auto d-flex p-0"
                            onClick={(e) => {
                                e.preventDefault()
                                dispatch(setFindHomeDataTwo(formik.values))
                            }}
                        >
                            <CustomImage
                                src="https://webb-jenkins-static-164679926.imgix.net/icons/back-arrow.svg"
                                alt="Back arrow"
                                height={12}
                                width={30}
                                className="me-1"
                            />
                            Back to previous step
                        </a>
                    </FormikForm>
                    // Find Home Form End
                )}
            </Formik>
        </>
    )
}

export default FindMeAHomeStepTwo
